import { AddressBook } from './addressBook.js';
import { ALL_SUPPORTED_CHAINS } from './constants/chains.js';
import { LimitOrder } from './limitOrder/index.js';
import { Permit } from './permit/index.js';
import { Price } from './price/index.js';
import { Signer } from './signer/index.js';
import { Swap } from './swap/index.js';
import {} from './utils/env.js';
import { createPublicClient, http, } from 'viem';
export class TokenlonSDK {
    config;
    swap;
    price;
    permit;
    signer;
    limitOrder;
    addressBook;
    publicClient;
    walletClient;
    constructor(config) {
        this.config = config;
        this.addressBook =
            config.addressBook ?? AddressBook.selectByChainID(config.chain);
        this.publicClient =
            config.client ??
                createPublicClient({
                    chain: ALL_SUPPORTED_CHAINS.find((c) => c.id === config.chain),
                    transport: http(undefined, {
                        batch: true,
                    }),
                });
        this.walletClient = config.walletClient;
        const commonServiceConfig = {
            env: config.env,
            chainId: config.chain,
        };
        this.price = new Price(commonServiceConfig, {
            publicClient: this.publicClient,
        });
        this.swap = new Swap(config, {
            publicClient: this.publicClient,
            walletClient: this.walletClient,
            price: this.price,
            addressBook: this.addressBook,
        });
        this.permit = new Permit(commonServiceConfig, {
            publicClient: this.publicClient,
            walletClient: this.walletClient,
            addressBook: this.addressBook,
        });
        this.signer = new Signer(commonServiceConfig, {
            publicClient: this.publicClient,
            walletClient: this.walletClient,
        });
        this.limitOrder = new LimitOrder(commonServiceConfig, {
            publicClient: this.publicClient,
            walletClient: this.walletClient,
        });
    }
}
//# sourceMappingURL=sdk.js.map